// AvatarPresence — Badge com dot pulsante (ripple) sobre o Avatar.
// Cor pelo helper único getPresence(status). Tooltip de presença (nome + status
// + duração + motivo) é OPCIONAL e on-demand: passe `userId` que ele embrulha
// num PresenceTooltip (consulta ao abrir). Sem `userId`, renderiza o badge puro.
import React from 'react';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import { getPresence } from '../../helpers/presence';
import PresenceTooltip from '../PresenceTooltip';

const StyledBadge = styled(Badge, {
    shouldForwardProp: (prop) => prop !== 'status',
})(({ theme, status }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: getPresence(status).color,
        color: getPresence(status).color,
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));

export default function AvatarPresence({ status, userId, children, ...rest }) {
    const badge = (
        <StyledBadge status={status} {...rest}>
            {children}
        </StyledBadge>
    );

    if (!userId) return badge;
    return <PresenceTooltip userId={userId}>{badge}</PresenceTooltip>;
}
